<div class="custom-accordion">

  <div *ngFor="let section of sections" [id]="'section-' + section.id" class="accordion-section"
    [class.section-open]="section.isOpen" [class.section-completed]="section.isCompleted">

    <!-- Section Header -->
    <div class="section-header" *ngIf="section.hasHeader" [ngClass]="{'can-click': !section.hasAddButton && !section.hasCompleteButton}"
      (click)="!section.hasAddButton && !section.hasCompleteButton ? toggleSection(section.id, $event) : null">

      <div class="header-left">
        <!-- Completion Icon -->
        <div class="completion-icon"
          [ngClass]="{'incomplete': !section.isCompleted && section.required, 'not-required': !section.required && !section.isCompleted}">
          <daz-icon *ngIf="section.isCompleted" [name]="'check'" [size]="'20px'" [color]="'#318836'">
          </daz-icon>
          <daz-icon *ngIf="!section.isCompleted && section.required" [name]="'exclamation'" [size]="'20px'"
            [color]="'#df2323'">
          </daz-icon>
          <daz-icon *ngIf="!section.isCompleted && !section.required" [name]="'optional'"
            pTooltip="{{ 'general.optional' | translate }}" [size]="'20px'" [color]="'#B67ED1'">
          </daz-icon>

        </div>

        <!-- Section Title and Subtitle -->
        <div class="header-text">
          <span class="section-title">{{ section.title }}</span>
          <span *ngIf="section.subtitle && !section.isOpen" class="section-subtitle">{{ section.subtitle }}</span>
        </div>
      </div>

      <div class="header-right">
        <!-- Add Button -->
        <hub-button *ngIf="section.hasAddButton" text="{{'bikeshop.shop_profile.collections.buttons.add' | translate}}"
          [disabled]="!buttonEnabled(section.id)" [size]="'sm'" [style]="'borderless-secondary'" [icon]="'plus'"
          (buttonClick)="onAddClick(section.id, $event)">
        </hub-button>

        <!-- Complete Button -->
        <hub-button *ngIf="section.hasCompleteButton" text="{{'general.complete' | translate}}"
          [disabled]="!buttonEnabled(section.id)" [size]="'sm'" [style]="'borderless-secondary'" [icon]="'plus'"
          (buttonClick)="onAddClick(section.id, $event)">
        </hub-button>

        <!-- Chevron Button -->
        <hub-button *ngIf="!section.hasAddButton && !section.hasCompleteButton" [size]="'lg'" [style]="'outline'"
          [icon]="section.isOpen ? 'chevron-up' : 'chevron-down'" (buttonClick)="toggleSection(section.id, $event)">
        </hub-button>
      </div>
    </div>

    <!-- Section Content -->
    <div class="section-content" [class.content-visible]="section.isOpen">

      <div class="content-wrapper">
        <!-- Customer Details Content -->
        <div *ngIf="section.id === 'customer-details' && section.isOpen">
          <app-workshop-jobcard-customer-details [jobcard]="jobcard" (jobcardChange)="onJobCardChange($event)"
                                                 [groupBookings]="groupBookings"></app-workshop-jobcard-customer-details>
        </div>

        <!-- Item Details Content -->
        <div *ngIf="section.id === 'item-details' && section.isOpen">
          <app-workshop-jobcard-item-details [jobcard]="jobcard" (jobcardChange)="onJobCardChange($event)"
                                             [jobCards]="jobCards"></app-workshop-jobcard-item-details>
        </div>

        <!-- Services and Products Content -->
        <div *ngIf="section.id === 'services-products' && section.isOpen">
          <app-workshop-jobcard-quote-search-area [jobcard]="jobcard" [serviceTypes]="serviceTypes"
                                                  (jobcardChange)="onJobCardChange($event)"
                                                  [productSKUServiceTypeCollection]="productSKUServiceTypeCollection"></app-workshop-jobcard-quote-search-area>
        </div>

        <!-- Collections & Deliveries Content -->
        <div *ngIf="section.id === 'collections-deliveries' && section.isOpen">
          <app-workshop-jobcard-collecions-deliveries [jobcard]="jobcard"
                                                      (jobcardChange)="onJobCardChange($event)"></app-workshop-jobcard-collecions-deliveries>
        </div>

        <!-- Booking Details Content -->
        <div *ngIf="section.id === 'booking-details' && section.isOpen">
          <app-workshop-jobcard-booking-details [jobcard]="jobcard" (jobcardChange)="onJobCardChange($event)"
                                                [serviceTypes]="serviceTypes" [technicians]="technicians" [systemUsers]="systemUsers"
                                                [thirdParties]="thirdParties"></app-workshop-jobcard-booking-details>
        </div>

        <!-- Checklists Content -->
        <div *ngIf="section.id === 'checklists' && section.isOpen">
          <app-workshop-jobcard-checklists [jobcard]="jobcard" (jobcardChange)="onPreServiceChecklistChange($event)"
                                           [preServiceChecklist]="preServiceChecklist"></app-workshop-jobcard-checklists>
        </div>

        <!-- Custom Questions Content -->
        <div *ngIf="section.id === 'custom-questions' && section.isOpen">
          <app-workshop-jobcard-custom-questions [jobcard]="jobcard"
                                                 (jobcardChange)="onJobCardChange($event)"></app-workshop-jobcard-custom-questions>
        </div>

        <!-- Extras -->
        <div *ngIf="section.id === 'extras' && section.isOpen">
          <app-workshop-jobcard-extras [jobcard]="jobcard"
                                       (jobcardChange)="onJobCardChange($event)"></app-workshop-jobcard-extras>
          <br/>
          <app-workshop-jobcard-tag-select [jobcard]="jobcard" (tagToggled)="tagToggled($event)"></app-workshop-jobcard-tag-select>
        </div>


        <!-- Quote -->
        <div *ngIf="section.id === 'quote' && section.isOpen">
          <app-workshop-jobcard-quote [jobcard]="jobcard" [serviceTypes]="serviceTypes"
                                      [isPhoneView]="isPhoneView"
                                      [productSKUServiceTypeCollection]="productSKUServiceTypeCollection"
                                      (jobcardChange)="onJobCardChange($event)"></app-workshop-jobcard-quote>
        </div>

      </div>
    </div>
  </div>

</div>
